import * as React from "react";
import uhaulStore from "../CustomRedux/UhaulStore";

export class IndicateAgentToGM extends React.Component {

  constructor(props) {
      super(props);
      this.state = {serviceBaseUrl: uhaulStore.getState().UhaulReducer.config.liveChatApiUrl}
  }

  render() {
      if (this?.props?.task?._task?.attributes?.type === "general-manager" && this?.props?.task?._task?.attributes?.agent != null)
      {
        return(<p className="warning centerized">You are talking with a U-Haul Agent.</p>)
      }
      else{
        return null;
      }
  }
}
